import { Tab, Tabs, TextField } from '@mui/material'
import React, { useState } from 'react'
import TableViewIcon from '@mui/icons-material/TableView';
import TableRowsIcon from '@mui/icons-material/TableRows';
import { DataTextArea } from './DataTextArea';
import { TableStructureSettings } from './TableStructureSettings';


function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div hidden={value !== index}>
      {value === index && (
        <>{children}</>
      )}
    </div>
  );
}

export const SettingPanel = (props) => {
  const { tableData, setTableData, setSeparator, configs, setConfigs } = props
  const [selectedTab, setSelectedTab] = useState(0)
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue)
  }
  return (
    <>
      <Tabs
        centered
        value={selectedTab}
        onChange={handleChange}
      >
        <Tab icon={<TableViewIcon />} iconPosition="start" label="Data" />
        <Tab icon={<TableRowsIcon />} iconPosition="start" label="Structure" />
      </Tabs>

      {/* Data Input */}
      <TabPanel value={selectedTab} index={0}>
        <DataTextArea
          tableData={tableData} setTableData={setTableData}
          setSeparator={setSeparator}
        />
      </TabPanel>
      {/* Structure */}
      <TabPanel value={selectedTab} index={1}>
        <TableStructureSettings configs={configs} setConfigs={setConfigs} />
      </TabPanel>
    </>
  )
}
